import PropTypes from 'prop-types'
import styled from 'styled-components'

import { TICKET_FILTER_OPERATOR_COLORS } from 'constants/constants'

import Badge from 'components/Shared/Badge/Index'

const StyledBadge = styled(Badge)`
  font-size: 14px;
`

const OperatorBadge = ({ name }) => {
  const color = TICKET_FILTER_OPERATOR_COLORS[name]
  return (
    <StyledBadge
      margin='0'
      color={color}
    >
      {name}
    </StyledBadge>
  )
}

OperatorBadge.propTypes = {
  name: PropTypes.string.isRequired,
}

export default OperatorBadge
